import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { TaxOldTable } from "./TaxOldTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./taxOldSlice";

export const TaxOldPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [date, setDate] = useState("");
  const [billingDoc, setBillingDoc] = useState("");
  const [taxInvoiceNumber, setTaxInvoiceNumber] = useState("");
  const [vatRegNo, setvatRegNo] = useState("");


  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      date: date,
      billingDoc: billingDoc,
      taxInvoiceNumber: taxInvoiceNumber,
      vatRegNo: vatRegNo,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    console.log("params", params);
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      date: date,
      billingDoc: billingDoc,
      taxInvoiceNumber: taxInvoiceNumber,
      vatRegNo: vatRegNo,
      pageNo: page,
      pageSize: sizePerPage,
    };
    console.log("params", params);
    dispatch(fetchAll(params));
  };
  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="SAP Tax Old"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Billing Date</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="date"
                    placeholder="Billing Date"
                    onChange={(e) => {
                      setDate(e.target.value);
                    }}
                    value={date}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Billing Doc</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Billing Doc"
                    onChange={(e) => {
                      setBillingDoc(e.target.value);
                    }}
                    value={billingDoc}
                  />
                </Col>
              </Form.Group>

            </Col>
            {/* Row kiri */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Tax Invoice Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Tax Invoice Number"
                    onChange={(e) => {
                      setTaxInvoiceNumber(e.target.value);
                    }}
                    value={taxInvoiceNumber}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>VAT Registration</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="VAT Registration"
                    onChange={(e) => {
                      setvatRegNo(e.target.value);
                    }}
                    value={vatRegNo}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <TaxOldTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
